import React from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import { DepartmentsBudgetsReportTableProvider } from './context/DepartmentsBudgetsReportTableContext';
import DepartmentsBudgetsReportTable from './DepartmentsBudgetsReportTable';

import { apiClient } from 'Helpers/network';

import useQuery from 'Hooks/useQuery';

const DepartmentsBudgetsSnapshot = ({ snapshotDataUrl }) => {
    const budgetsDataRequest = useQuery({
        queryFn: () => apiClient.get(snapshotDataUrl),
    });

    return (
        <div className="tw-h-full tw-flex tw-flex-col tw-space-y-6 tw-py-12">
            <DepartmentsBudgetsReportTableProvider
                criteria={budgetsDataRequest.data?.criteria}
                report={budgetsDataRequest.data?.report}
                budgets={budgetsDataRequest.data?.budgets}
                comments={budgetsDataRequest.data?.comments}
                loading={budgetsDataRequest.loading}
            >
                <DepartmentsBudgetsReportTable budgetsData={budgetsDataRequest.data?.budgets_data || []} />
            </DepartmentsBudgetsReportTableProvider>
        </div>
    );
};

if (document.getElementById('DepartmentsBudgetsSnapshot')) {
    var rootEl = document.getElementById('DepartmentsBudgetsSnapshot');
    const snapshotDataUrl = rootEl.getAttribute('data-snapshot-data-url');
    ReactDOM.render(
        <App>
            <DepartmentsBudgetsSnapshot snapshotDataUrl={snapshotDataUrl} />
        </App>,
        rootEl,
    );
}
